var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SettingsLayout", [
    _c("div", { staticClass: "accommodations-view" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "section",
          [
            _c("unit-type-modal", { ref: "newUnitTypeModal" }),
            _vm._v(" "),
            _c("unit-modal", { ref: "unitModal" }),
            _vm._v(" "),
            _vm.isRequestingUnits || _vm.isRequestingUnitTypes
              ? _c(
                  "section",
                  [
                    _c("spinner-loader", {
                      staticClass: "centerscreen",
                      attrs: {
                        loading:
                          _vm.isRequestingUnits || _vm.isRequestingUnitTypes,
                      },
                    }),
                  ],
                  1
                )
              : _vm.errored
              ? _c("section", [_c("p", [_vm._v("An error occurred.")])])
              : _c(
                  "section",
                  { staticClass: "content-container" },
                  [
                    _c(
                      "b-row",
                      { staticClass: "mb-4", attrs: { "align-h": "between" } },
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: { placeholder: _vm.$t("filter_cat") },
                                  model: {
                                    value: _vm.filter,
                                    callback: function ($$v) {
                                      _vm.filter = $$v
                                    },
                                    expression: "filter",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "text-right", attrs: { md: "4" } },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary" },
                                on: { click: _vm.showNewUnitTypeModal },
                              },
                              [
                                _c("i", { staticClass: "fi-plus mr-1" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "settings.accommodations.unit_type.create"
                                      )
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.visibleUnitTypes.length > 0
                      ? _c(
                          "div",
                          _vm._l(
                            _vm.visibleUnitTypes,
                            function (unitType, index) {
                              return _c(
                                "b-card",
                                {
                                  key: unitType.id,
                                  staticClass: "mb-3 unit-type-accordion",
                                  attrs: { "no-body": "" },
                                },
                                [
                                  _c(
                                    "b-card-header",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center p-3",
                                      class: {
                                        "unit-type-header-active":
                                          _vm.activeAccordion === index,
                                      },
                                      attrs: {
                                        "header-tag": "header",
                                        role: "button",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleAccordion(index)
                                        },
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _c("h5", { staticClass: "mb-0" }, [
                                          _vm._v(
                                            _vm._s(unitType.unit_type_name)
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "text-muted small" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  unitType.unit_type_description
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "mr-4 font-weight-bold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.getVendor.local_currency
                                                  ) +
                                                  _vm._s(unitType.base_rate) +
                                                  "/" +
                                                  _vm._s(_vm.$t("night")) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass: "accordion-icon",
                                            class:
                                              _vm.activeAccordion === index
                                                ? "fi-chevron-up"
                                                : "fi-chevron-down",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-collapse",
                                    {
                                      attrs: {
                                        visible: _vm.activeAccordion === index,
                                      },
                                    },
                                    [
                                      _c(
                                        "b-card-body",
                                        { staticClass: "p-0" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "unit-type-content",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "unit-type-actions d-flex justify-content-between align-items-center mb-3",
                                                },
                                                [
                                                  _c("h6", {
                                                    staticClass: "mb-0",
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            size: "sm",
                                                            variant:
                                                              "outline-primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.editUnitType(
                                                                unitType
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fi-pencil mr-1",
                                                          }),
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t("edit")
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-button",
                                                        {
                                                          attrs: {
                                                            size: "sm",
                                                            variant: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.showAddRoomModal(
                                                                unitType.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fi-plus mr-1",
                                                          }),
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "unit_add_room_button"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              unitType.unit &&
                                              unitType.unit.length > 0
                                                ? _c("div", [
                                                    _c(
                                                      "table",
                                                      {
                                                        staticClass:
                                                          "table rooms-table mb-0",
                                                      },
                                                      [
                                                        _c("thead", [
                                                          _c("tr", [
                                                            _c("th", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t("name")
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("th", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "description"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "text-right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "rate"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "text-right",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "actions"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "tbody",
                                                          _vm._l(
                                                            unitType.unit,
                                                            function (room) {
                                                              return _c(
                                                                "tr",
                                                                {
                                                                  key: room.id,
                                                                },
                                                                [
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticClass:
                                                                        "font-weight-bold",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            room.unit_name
                                                                          ) +
                                                                          "\n                            "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticClass:
                                                                        "text-muted",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            room.unit_description
                                                                          ) +
                                                                          "\n                            "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticClass:
                                                                        "text-right room-rate",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .getVendor
                                                                              .local_currency
                                                                          ) +
                                                                          _vm._s(
                                                                            room.unit_rate
                                                                          ) +
                                                                          "/" +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "night"
                                                                            )
                                                                          ) +
                                                                          "\n                            "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticClass:
                                                                        "text-right",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              size: "sm",
                                                                              variant:
                                                                                "outline-primary",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.editRoom(
                                                                                  unitType.id,
                                                                                  room
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fi-pencil",
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                  ])
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center p-4 no-rooms",
                                                    },
                                                    [
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "No rooms added yet"
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        )
                      : _c(
                          "b-card",
                          { staticClass: "text-center p-5" },
                          [
                            _c("p", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("no_unit_types_message") ||
                                      "No room types added yet"
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary" },
                                on: { click: _vm.showNewUnitTypeModal },
                              },
                              [
                                _c("i", { staticClass: "fi-plus mr-1" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "settings.accommodations.unit_type.create"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }